import { PaginationDotsProps } from './onboarding.types';

/**
 * Pagination Dots Component
 *
 * Displays navigation dots for the onboarding carousel.
 * Active dot is elongated with a primary color glow effect.
 *
 * Specs from panel.html:
 * - Active: h-2 w-8 rounded-full bg-primary shadow-[0_0_10px_primary/50]
 * - Inactive: h-2 w-2 rounded-full bg-white/20
 */
export function PaginationDots({ total, activeIndex }: PaginationDotsProps) {
  return (
    <div className="flex flex-row items-center gap-2">
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className={`h-2 rounded-full transition-all duration-300 ${
            index === activeIndex
              ? 'w-8 bg-primary shadow-[0_0_10px_var(--color-primary)]'
              : 'w-2 bg-white/20'
          }`}
        />
      ))}
    </div>
  );
}
